import { router } from "expo-router";
import { useCallback } from "react";

import Button from "$src/core/components/atoms/Button/Button";
import useTranslation from "$src/core/hooks/use-translation";

import type { PlayContentButtonProps } from "./types";

const PlayContentButton = ({
  ref,
  name,
  preset = "primary",
  contentId,
  contentType,
  trailer = false,
  ...restProps
}: PlayContentButtonProps) => {
  const { t } = useTranslation();

  const handlePress = useCallback(() => {
    router.navigate(`/${contentType}/${contentId}/play?trailer=${trailer}`);
  }, [contentType, contentId, trailer]);

  const label = trailer ? t("DETAIL/TRAILER") : t("DETAIL/PLAY");
  const icon = trailer ? "movie" : "play";
  const accessibilityLabel = trailer
    ? t("DETAIL/TRAILER/ACCESSIBILITY_LABEL")
    : t("DETAIL/PLAY/ACCESSIBILITY_LABEL");

  return (
    <Button
      ref={ref}
      name={name}
      preset={preset}
      label={label}
      icon={icon}
      onPress={handlePress}
      accessibilityLabel={accessibilityLabel}
      {...restProps}
    />
  );
};

export default PlayContentButton;
